import React from 'react'

import { Checkbox as CheckboxInput, InfoTooltip, withFormikSupport } from '@fourthwall/components'

import * as S from './Checkbox.styled'
import type { Props } from './types'

const CheckboxComponent = ({ data, value, onChange, onBlur, onSettingUpdate }: Props) => {
  const { label, id, info } = data

  const handleChange = (newValue: any) => {
    onChange(newValue)
    onSettingUpdate(id, newValue)
  }

  const handleBlur = (e: any) => {
    if (onBlur) {
      onBlur(e.target.value)
    }
  }

  const getValue = () => {
    if (typeof value === 'string') {
      return value === 'true'
    }

    return value
  }

  return (
    <S.Container>
      <S.CheckboxContainer>
        <CheckboxInput
          label={label}
          value={getValue()}
          onValueChange={handleChange}
          onBlur={handleBlur}
        />
      </S.CheckboxContainer>
      <InfoTooltip content={info} />
    </S.Container>
  )
}

export const Checkbox = withFormikSupport(CheckboxComponent)
